import script from "./LocationElement.vue?vue&type=script&lang=js"
export * from "./LocationElement.vue?vue&type=script&lang=js"

import "./LocationElement.vue?vue&type=style&index=0&id=5723a460&lang=scss"

const __exports__ = script;

export default __exports__